import './ApexCodeHighlight.scss';

import { AiExplainButton } from './AiExplainButton';
import classNames from 'classnames';
import { CodeItem } from '@ui/general/CodeItem';
import React from 'react';
import { useBoolean } from '@hooks';

import { ApexCodeSpan, LinkKind, SonarObjectType } from '@sonar-software/sonar-ts-types';

type ApexCodeHighlightProps = {
	apexSonarObjectId?: number;
	spans: ApexCodeSpan[];
	index: number;
};

const placeholder = '...';

const getSonarObjectType = (syntaxKind: LinkKind) => {
	switch (syntaxKind) {
		case LinkKind.SfdcApexClass:
			return SonarObjectType.SalesforceApexClass;
		case LinkKind.SfdcEntity:
			return SonarObjectType.SalesforceEntity;
		case LinkKind.SfdcField:
			return SonarObjectType.SalesforceField;
		default:
			return '';
	}
};

export const ApexCodeHighlight: React.FC<ApexCodeHighlightProps> = ({ apexSonarObjectId, spans, index }) => {
	const [ showExplain, setShowExplain ] = useBoolean(false);

	if (!spans) {
		return <div>{ placeholder }</div>;
	}

	return (
		<div
			className='apex-code'
			onMouseEnter={ setShowExplain.on }
			onMouseLeave={ setShowExplain.off }>
			{ apexSonarObjectId && <AiExplainButton
				hidden={ !showExplain }
				sonarObjectId={ apexSonarObjectId } /> }
			<div className='apex-code-inner'>
				{ spans.map(([ text, linkType, sonarObjectId, syntaxKind ], i) => {
					const type = getSonarObjectType(linkType);

					const periscopeOptions = type ? {
						id: sonarObjectId,
						name: '',
						openedFromIndex: index,
						type
					} : undefined;

					const className = classNames(`highlight-${syntaxKind || linkType}`);
					const key = `${i}-${text}`;

					return (
						<CodeItem
							className={ className }
							code={ text }
							key={ key }
							sections={ {
								periscopeOptions
							} } />
					);
				}) }
			</div>
		</div>
	);
};
